import { render, staticRenderFns } from "./dnd-intervals.vue?vue&type=template&id=83b7e886&scoped=true&"
import script from "./dnd-intervals.vue?vue&type=script&lang=js&"
export * from "./dnd-intervals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b7e886",
  null
  
)

export default component.exports